const digitRegEx = /[\d+.]/g;
const parseDigits = (input: string) => (input.match(digitRegEx) || []).join('');

export const formatInt = (input: string) => {
    if (digitRegEx.test(input)) {
        input = input.replace(/\./g, '').replace(/,/g, '.');
        return new Intl.NumberFormat('da-DK', { maximumFractionDigits: 0 }).format(parseInt(parseDigits(input)));
    }
    return '';
};
